import _ from 'underscore';
import { INotification, TargetComponent, NotificationLevel, DismissMode, ScopeLevel, IContext } from '../../types';
import { isBillingLinkPermission } from '../../utils';

const notificationTitle = _TL_('Important Hotel Center update');
const notificationMessage = _TL_('In response to customer feedback, we’ve temporarily paused the February 6th change for Hotel Center. However, in the near future, we’ll still change the set up and management of Hotel price ads and Property promotion ads. We strongly encourage you to convert your existing campaigns to Lodging campaigns to proactively help the migration process and avoid future disruptions.');

export class HotelCenterMigrationPhase2Notification {
  context: IContext;
  i18n: any;
  availableScopes: ScopeLevel[];

  constructor(context: IContext) {
    this.context = context;
    this.i18n = context.getNewI18n();
    this.availableScopes = [ScopeLevel.account, ScopeLevel.customer];
  }

  async getHotelCenterMigrationPhase2Notifications() {
    if (!this.context.getUserContext().CurrentUser.IsInternal && isBillingLinkPermission(this.context.getSettingsContext())) {
      return [];
    }

    const currentPermissions = this.context.getCurrentPermissions();
    const isHotelCenterEnabled = currentPermissions && currentPermissions.dynamic.HotelAds;
    const isHotelCenterRemovalEnabled = currentPermissions && currentPermissions.dynamic.HotelCenterRemoval;
    if (!isHotelCenterEnabled || isHotelCenterRemovalEnabled) {
      return [];
    }

    // Get notifications
    const notifications: INotification[] = [{
      id: 'HotelCenterPhase2Migration',
      condition: true,
      target: TargetComponent.UnifiedQueue,
      dismissMode: DismissMode.session,
      severity: NotificationLevel.Info,
      scopeLevel: ScopeLevel.account,
      availableScopes: this.availableScopes,
      title: this.i18n.getString(notificationTitle),
      message: this.i18n.getString(notificationMessage),
      actionList: [],
    }];


    return _.compact(notifications);
  }
}
